//App
import {
  LookupValueContextData,
  LookupValueProps,
  LookupValueState,
} from "../../../../../types/lookupValue";
import { LookupValueContext } from "../LookupValueContainer";
import useForm from "../../../../hooks/useForm";
import { useMutation, useQuery } from "@tanstack/react-query";

//App
import { queryKeys } from "../constants";
import lookupValueApi from "../../../../../app/model/api/lookupValueApi";
import {
  EMPTY_GUID,
  GRID_PAGE_SIZE,
} from "../../../../../utility/constants";

const useLookupValue = (props: LookupValueProps) => {
  return useForm<LookupValueContextData, LookupValueProps>(
    LookupValueContext,
    props
  );
};

export const useDeleteMutation = () =>
  useMutation<void, Error, string>({
    mutationFn: async (value: string) => {
      await lookupValueApi.delete(value);
    },
  });

export const useActivateMutation = () =>
  useMutation<void, Error, string>({
    mutationFn: async (value: string) => {
      await lookupValueApi.activate(value);
    },
  });

export const useLookupValuesGridQuery = (state: LookupValueState) =>
  useQuery({
    queryKey: [
      queryKeys.getLookupValues,
      state.lookupTypeId,
      state.currentPage,
    ],
    queryFn: () =>
      lookupValueApi.searchLookupValues({
        ...state.searchPayload,
        lookupTypeId: state.lookupTypeId ?? null,
        lookupGroupId: state.lookupGroupId ?? null,
        pageSize: state.pageSize,
        pageNumber: state.currentPage ?? 1,
        isActive: state.activeToggle,
        sortBy: state.sortBy ?? [],
      }),
  });

export const useLookupValueQuery = (lookupValueId: string | null) =>
  useQuery({
    queryKey: [queryKeys.getLookupValue, lookupValueId],
    queryFn: () => lookupValueApi.get(lookupValueId ?? EMPTY_GUID),
    enabled: lookupValueId !== null,
  });

export default useLookupValue;
